import {
    UserGroupIcon,
    UserIcon,
    KeyIcon,
} from "@heroicons/react/24/outline";

const UserManagementRoutes = [
    {
        path: "user-management",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "User Management",
        icon: UserGroupIcon,
        children: [
            {
                path: "users",
                fullPath: "user-management/users",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Users",
                displayPath: "User Management > Users",
                icon: UserIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/users/UserList"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["user-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/users/UserAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["user-create"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/users/UserAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["user-create"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/users/details/Details"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["user-list", "user-edit", "user-delete"],
                    },
                ],
            },
            {
                path: "roles",
                fullPath: "user-management/roles",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Roles",
                displayPath: "User Management > Roles",
                icon: KeyIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/roles/Roles"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["role-list"],
                    },
                    {
                        path: "new",
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/roles/RoleAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["role-create"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/roles/RoleAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["role-edit"],
                    },
                ],
            },
            {
                path: "user-group",
                fullPath: "user-management/user-group",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "User Group",
                displayPath: "User Management > User Group",
                icon: UserGroupIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/UserGroup/List"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["user-group-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/UserGroup/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["user-group-create"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/UserGroup/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["user-group-edit"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/UserGroup/Details"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["user-group-edit"],
                    },
                ],
            },
        ],
    },
];

export default UserManagementRoutes;
